module.exports = __webpack_public_path__ + "static/media/goods_title@3x.256aa7e6.png";